import { render } from "./Webchat.vue?vue&type=template&id=32cddb76"
import script from "./Webchat.vue?vue&type=script&lang=js"
export * from "./Webchat.vue?vue&type=script&lang=js"

import "./Webchat.vue?vue&type=style&index=0&id=32cddb76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__